import { render, staticRenderFns } from "./chooseAddress.vue?vue&type=template&id=657b377c&scoped=true&"
import script from "./chooseAddress.vue?vue&type=script&lang=js&"
export * from "./chooseAddress.vue?vue&type=script&lang=js&"
import style0 from "./chooseAddress.vue?vue&type=style&index=0&id=657b377c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657b377c",
  null
  
)

export default component.exports